import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import HelperForMetaData from "../../../Helpers/HelperForMetaData";

const UpdateTransport = async (FormData, TransportID) => {
  try {
    const TransportDocument = doc(db, "Transports", TransportID);

    const data = {
      ...FormData,
      ...HelperForMetaData({}),
    };

    delete data.createdAt;
    delete data.createdBy;

    await updateDoc(TransportDocument, data);

    return true;
  } catch (error) {
    console.log(error);

    return false;
  }
};

export default UpdateTransport;
